import type { ValueOrCondition } from '@unifyapps/defs/types/conditionalValueFilters';
import type { LCColorValue } from '@unifyapps/defs/types/styleObject';
import { getConditionalPropertyValue } from '../../../utils/conditionalValues';

export const getColorClassNameAndValue = (color: ValueOrCondition<LCColorValue> | undefined) => {
  const computedColor = getConditionalPropertyValue<LCColorValue>({
    value: color,
  });

  if (typeof computedColor === 'object') {
    return { value: computedColor.custom };
  }

  return { className: computedColor };
};
